import { createAction } from "@reduxjs/toolkit";
import axios from 'apis';
import { asyncThunkWrapper } from "helpers/asyncThunkWrapper";

export const getAppointmentFlow = asyncThunkWrapper({ 
  model: 'appointmentFlows', 
  action: 'getAppointmentFlow', 
  func: async () => {
    const attributes = ['id', 'email', 'mail_prompt', 'appointment_prompt', 'patient_prompt', 'clinicians_prompt', 'slots_prompt', 'updated_at'];
    const params = { attributes };
    const response = await axios.get(`/appointment_flow`, { params });

    return response.data;
  } 
});
export const createAppointmentFlow = asyncThunkWrapper({ 
  model: 'appointmentFlows', 
  action: 'createAppointmentFlow', 
  func: async (appointment_flow) => {
    const attributes = ['id', 'email', 'mail_prompt', 'appointment_prompt', 'patient_prompt', 'clinicians_prompt', 'slots_prompt', 'updated_at'];
    const response = await axios.post(`/appointment_flow`, { appointment_flow, attributes });

    return response.data;
  } 
});
export const updateAppointmentFlow = asyncThunkWrapper({ 
  model: 'appointmentFlows', 
  action: 'updateAppointmentFlow', 
  func: async (appointment_flow) => {
    const response = await axios.patch(`/appointment_flow`, { appointment_flow });

    return { status: response.status, appointment_flow };
  } 
});
export const deleteAppointmentFlow = asyncThunkWrapper({ 
  model: 'appointmentFlows', 
  action: 'deleteAppointmentFlow', 
  func: async () => {
    const response = await axios.delete(`/appointment_flow`);

    return { status: response.status };
  } 
});
export const clearLocalActiveAppointmentFlow = createAction('appointmentFlows/clearLocalActiveAppointmentFlow');